import { render, staticRenderFns } from "./calendar-week.vue?vue&type=template&id=fb7d8a36&"
import script from "./calendar-week.vue?vue&type=script&lang=ts&"
export * from "./calendar-week.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports